import { api } from './apiServices'; // configured axios instance -> core API, sends admin JWT

// --- Manual invoice trigger (relocated into core under Permission.INVOICES_MANAGE) ---
export const manualTriggerInvoice = (unifiedPaymentId) => {
  return api.post('/admin/system-tools/manual-invoice', {
    unified_payment_id: Number(unifiedPaymentId),
  });
};

// --- WhatsApp test ping (relocated into core under Permission.MANAGE_ADMIN_USER) ---
export const whatsappTestPing = ({ toPhone, templateName } = {}) => {
  const payload = {};
  if (toPhone) payload.to_phone = toPhone;
  if (templateName) payload.template_name = templateName;
  return api.post('/admin/system-tools/whatsapp-test-ping', payload);
};

// --- Non-prod DB start/stop (core /system/manage-db; endpoint itself refuses in prod) ---
export const manageDb = (action) => {
  // action: "start" | "stop"
  return api.get('/system/manage-db', { params: { action } });
};

// --- Dev/debug tools (core /test/*; these routers are excluded entirely in prod) ---
export const getDebugPackages = () => {
  return api.get('/test/debug-packages');
};

export const testPushNotification = (leadId, sellerProfileId) => {
  return api.post('/test/test-push', {
    lead_id: Number(leadId),
    seller_profile_id: Number(sellerProfileId),
  });
};

export const getLeadVisibility = (leadId, sellerProfileId) => {
  return api.get(`/test/lead-visibility/${Number(leadId)}/${Number(sellerProfileId)}`);
};
